import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massForceDeleteUsers } from "../../api/apiUsers";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف جماعي نهائي للمستخدمين
 */
export function useForceDeleteAllUsers() {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAllUsersMutate,
        isPending,
    } = useMutation({
        mutationFn: massForceDeleteUsers,
        onSuccess: (response) => {
            toast.success(response.message || "Force deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["users"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to force delete users");
        },
    });

    return {
        forceDeleteAllUsersMutate,
        isPending,
    };
}